import { FC } from "react"
import { css, Theme } from "@emotion/react"
import { Icon } from "@ncs/web-legos/components"

interface FooterMessageProps {
	brand: "square" | "stripe"
}

export const FooterMessage: FC<FooterMessageProps> = ({ brand }) => (
	<div css={squareContainer}>
		<div>
			<Icon icon="lock" css={lock} family="solid" />
			<p css={squareText}>Secured with</p>
		</div>
		<img src={`/payments/logos/${brand}.svg`} css={logo} alt={`${brand} logo`} />
	</div>
)

const squareContainer = (theme: Theme) => css`
	display: flex;
	flex-direction: row;
	border-radius: 4px;
	background: #f3f4f6;
	padding: 0.6rem;
	align-items: center;
	width: fit-content;
	margin-bottom: 1.5rem;

	> div {
		display: flex;
		align-items: center;
	}

	${theme.breakpoints.down("xs")} {
		flex-direction: column;
		align-items: flex-start;
	}
`

const lock = css`
	color: #10a85f;
	width: 1rem;
	margin-right: 0.75rem;
`

const squareText = css`
	color: #4b5563;
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	margin-right: 0.3rem;
`

const logo = (theme: Theme) => css`
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 21px;
	margin-right: 0.3rem;

	${theme.breakpoints.down("xs")} {
		margin-left: 1.8rem;
		margin-right: 0rem;
		margin-top: 0.25rem;
	}
`
